<template>
  <div class="position_relative">
    <div class="padding_content" id="padding_support">
      <div class="support_content">
        <div class="box-card" v-for="(item, index) in dataList" :key="index">
          <div class="type">{{ item.name }}</div>
          <div v-for="(value, key) in item.subMenu" class="text" :key="key">
            <span class="logo"><i class="icon-document"></i></span>
            <span class="title">{{ value.title }}</span>
            <a
              :href="value.url"
              :class="value.url === 'javascript:void(0);' ? 'color_gray' : ''"
              :title="value.title"
              ><i class="el-icon-download"></i
            ></a>
          </div>
        </div>
      </div>
    </div>
    <supportFooter></supportFooter>
  </div>
</template>

<script>
import supportFooter from '@/components/supportFooter'
import { downAPP } from './public/validator'

export default {
  name: 'Support',
  components: { supportFooter },
  computed: {
    dataList() {
      return this.$t('support')
    }
  },
  mounted() {
    downAPP('padding_support', '180px')
  }
}
</script>

<style lang="scss" scoped>
.type {
  font-size: 16px;
  color: rgba(43, 62, 81, 1);
  font-family: NexaBold;
  margin-bottom: 24px;
  height: 24px;
  line-height: 24px;
}
.text {
  width: 100%;
  height: 50px;
  background: $white;
  font-size: 16px;
  color: rgba(43, 62, 81, 1);
  @include flex-align-center;
  @include border-radius(4px);
  margin-bottom: 4px;
  box-sizing: border-box;
  padding: 0 29px 0 16px;
  &:hover {
    box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
  }
  &:last-child {
    margin-bottom: 60px;
  }
  .logo {
    display: inline-block;
    width: 30px;
    height: 30px;
    font-size: 30px;
  }
  .title {
    text-align: center;
    flex: 1;
    font-size: 14px;
    color: rgba(43, 62, 81, 0.7);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  & > a {
    color: #f56a40;
  }
  .color_gray {
    color: #ccc;
    cursor: not-allowed;
  }
}

::v-deep .el-icon-download {
  font-weight: 900;
}

@media screen and (max-width: 450px) {
  .padding_content {
    padding-bottom: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/support.vue